export default {
  NEWS_LOAD: 'NEWS_LOAD'
};


// WEBPACK FOOTER //
// ./modules/news/constants/NewsConstants.js